import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'material-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    standalone: false,
})
export class MaterialCheckboxComponent implements OnInit, OnDestroy, OnChanges {
    @Input() name: string | null;
    @Input() id: string;
    @Input() disabled: boolean;
    @Input() model: any;
    @Input() showName: boolean;
    @Input() description: string;
    @Input() indeterminate: boolean;
    @Input() tailwindClasses: string[];
    @Input() badge: number;
    @Input() labelTextClass = '';

    @Output() change = new EventEmitter();
    @Output() modelChange = new EventEmitter();

    control = new UntypedFormControl('');
    valueSubscription: Subscription;
    displayName = '';

    constructor() {}

    private updateDisplayName(): void {
        this.displayName = this.showName ? this.name || '' : '';
    }

    customOnChange($event) {
        this.change.emit($event);
    }

    modelChanged = event => {
        this.model = event;
        this.modelChange.emit(event);
    };

    ngOnInit() {
        this.valueSubscription = this.control.valueChanges.subscribe(event => this.modelChanged(event));
        this.updateDisplayName();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.showName || changes.name) {
            this.updateDisplayName();
        }
    }

    ngOnDestroy() {
        // Called once, before the instance is destroyed.
        this.valueSubscription && this.valueSubscription.unsubscribe();
    }
}
